import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { api } from "@/api";
import { makeBaseLayer, loadMapConfig } from "@/lib/mapBase";
import { MapPin } from "lucide-react";

const pin = (color = "#dc2626") => L.divIcon({
  className: "",
  html: `<div style="width:20px;height:20px;border-radius:50% 50% 50% 0;background:${color};border:2px solid #fff;transform:rotate(-45deg);box-shadow:0 1px 4px rgba(0,0,0,.4)"></div>`,
  iconAnchor: [10, 18],
});

export default function PopoutMap() {
  const { id } = useParams();
  const el = useRef(null);
  const mapRef = useRef(null);
  const baseRef = useRef(null);
  const [inc, setInc] = useState(null);
  const [sat, setSat] = useState(false);

  useEffect(() => {
    document.title = "Kaart — DispatchMe";
    api.get(`/incidents/${id}`).then(({ data }) => setInc(data)).catch(() => {});
  }, [id]);

  useEffect(() => {
    if (!inc || !el.current || mapRef.current) return;
    const lat = inc.building ? inc.building.lat : inc.location_lat;
    const lng = inc.building ? inc.building.lng : inc.location_lng;
    if (lat == null || lng == null) return;
    const map = L.map(el.current, { zoomControl: true, attributionControl: false }).setView([lat, lng], 16);
    mapRef.current = map;
    L.marker([lat, lng], { icon: pin() }).addTo(map)
      .bindPopup(inc.building ? inc.building.name : (inc.location_label || "Locatie")).openPopup();
    loadMapConfig().then((cfg) => { baseRef.current = makeBaseLayer(cfg || {}, sat).addTo(map); baseRef.current.bringToBack(); });
    setTimeout(() => map.invalidateSize(), 150);
  }, [inc]); // eslint-disable-line

  useEffect(() => {
    const map = mapRef.current; if (!map) return;
    loadMapConfig().then((cfg) => {
      if (baseRef.current) map.removeLayer(baseRef.current);
      baseRef.current = makeBaseLayer(cfg || {}, sat).addTo(map);
      baseRef.current.bringToBack();
    });
  }, [sat]);

  const hasCoords = inc && ((inc.building && inc.building.lat != null) || inc.location_lat != null);
  return (
    <div className="flex h-screen flex-col bg-slate-900" data-testid="popout-map">
      <div className="flex items-center justify-between gap-2 px-4 py-2 text-sm font-semibold text-white">
        <span className="inline-flex items-center gap-2 truncate"><MapPin className="h-4 w-4" /> {inc ? `${inc.title} · ${inc.ref}` : "Kaart"}</span>
        <button data-testid="popout-map-sat" onClick={() => setSat((s) => !s)}
          className={`rounded-lg border px-2.5 py-1 text-[11px] ${sat ? "border-blue-400 bg-blue-600" : "border-white/20 bg-white/10 hover:bg-white/20"}`}>
          {sat ? "Satelliet aan" : "Satelliet"}
        </button>
      </div>
      {inc && !hasCoords ? (
        <div className="flex flex-1 items-center justify-center text-sm text-slate-400" data-testid="popout-map-nocoords">Locatie onbekend voor dit incident</div>
      ) : (
        <div ref={el} className="flex-1" data-testid="popout-map-canvas" />
      )}
    </div>
  );
}
